export const Blue = "#0A84FF";
export const Red = "#FF375F";
export const Black = "#000";
export const Grey = "#C7C7CC";
export const White = "#FFFFFF";
